<template>
  <div class="row">
    <div class="col-20">
      <title-block
        :title="$t('view-CampaignsCpc.Delete.title')"
      />
      <validation-observer
        ref="observer"
      >
        <div class="row">
          <div class="col-20 std-wrapper mt-0 p-3 px-4 pt-4 mt-2">
            <page-loader
              v-if="loader"
            />
            <div class="row">
              <div class="col-20 text-center">
                {{ campaign.canBeDeleted ? $t('view-CampaignsCpc.Delete.info-can-be-deleted') : $t('view-CampaignsCpc.Delete.info-can-not-be-deleted') }}
                <br>
                {{ $t('view-CampaignsCpc.Delete.continue') }}
              </div>
            </div>
          </div>
        </div>
      </validation-observer>

      <div class="row my-5">
        <div class="col-20 text-center">
          <std-button
            type="C"
            :title="$t('common.button.back')"
            add-class="mx-2 my-2"
            :direction="'left'"
            :route-link="{ name: 'campaign-cpc-details', params: { id: campaignCpcId } }"
          />
          <std-button
            type="D"
            :title="$t('view-CampaignsCpc.Delete.button.end-campaign')"
            add-class="mx-2 my-2"
            :loader="buttonLoader"
            @click="submitHandler"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      loader: true,
      buttonLoader: false,
      campaignCpcId: 0
    }
  },
  computed: {
    campaign () {
      const campaignCpc = this.$store.getters['campaignsCpcAdvertiser/getItem'](this.campaignCpcId)
      return campaignCpc || { name: '' }
    }
  },
  created () {
    this.campaignCpcId = this.$route.params.id || false
    if (this.campaignCpcId) {
      this.$store.dispatch('campaignsCpcAdvertiser/getOne', this.campaignCpcId)
        .then((result) => {
          this.loader = false
        })
        .catch(() => {
          this.$router.push({ name: 'campaigns-cpc' })
        })
    } else {
      this.$router.push({ name: 'campaigns-cpc' })
    }
  },
  methods: {
    submitHandler: async function () {
      if (this.buttonLoader) {
        return
      }

      this.buttonLoader = true
      const deleted = this.campaign.canBeDeleted

      this.$store.dispatch('campaignsCpcAdvertiser/delete', this.campaignCpcId)
        .then((newItem) => {
          this.buttonLoader = false
          this.$flash.success(deleted ? this.$t('view-CampaignsCpc.Delete.message.successfull.deleted') : this.$t('view-CampaignsCpc.Delete.message.successfull'))
          this.$router.push({ name: 'campaigns-cpc' }).catch(() => {})
        })
        .catch((e) => {
          this.$flash.error(this.$t('view-CampaignsCpc.Delete.message.error'))
          this.buttonLoader = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
